import Checkbox from '@mui/material/Checkbox';
import CheckOn from '../../images/LanguageIcons/language-check-on.svg';
import CheckOff from '../../images/LanguageIcons/language-check-off.svg';
import i18n from '../../utils/i18n';

const CheckboxService = ({
	id,
	title,
	subTitle,
	isSelected,
	onSelect,
	className = '',
}) => {
	const isMobile = window.innerWidth < 480;
	return (
		<div
			className={className}
			style={{
				display: 'flex',
				borderRadius: '6px',
				overflow: 'hidden',
				border: '1px solid #e0e0e0',
				backgroundColor: '#fff',
				height: isMobile ? 'auto' : '86px',
				marginBottom: '8px',
				cursor: 'pointer',
			}}
			onClick={onSelect}>
			<div
				style={{
					backgroundColor: '#fafcfe',
					padding: '16px',
					display: 'flex',
					alignItems: 'center',
					borderRight: '1px solid #e0e0e0',
				}}>
				<Checkbox
					id={id}
					checked={isSelected}
					onChange={onSelect}
					icon={
						<img
							src={CheckOff}
							alt={i18n.t('general.uncheckedIcon')}
							style={{
								width: '16px',
								height: '16px',
								cursor: 'pointer',
							}}
						/>
					}
					checkedIcon={
						<img
							src={CheckOn}
							alt={i18n.t('general.checkedIcon')}
							style={{
								width: '16px',
								height: '16px',
								cursor: 'pointer',
							}}
						/>
					}
					style={{
						padding: 0,
					}}
					onClick={(e) => e.stopPropagation()}
				/>
			</div>

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					padding: '8px 12px',
					cursor: 'pointer',
				}}>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<span
						style={{
							fontSize: '14px',
							fontWeight: 700,
							color: '#0b0f31',
							marginBottom: '4px',
						}}>
						{title}
					</span>
				</div>
				<span
					style={{
						fontSize: '12px',
						color: '#8791b4',
						lineHeight: '18px',
					}}>
					{subTitle}
				</span>
			</div>
		</div>
	);
};

export default CheckboxService;
